import { render, staticRenderFns } from "./TrashUsersPage.vue?vue&type=template&id=6aa8e5e4"
import script from "./TrashUsersPage.vue?vue&type=script&lang=js"
export * from "./TrashUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports